import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import App from '@/App.vue'
import router from '@/router'
import { pasangSinkronAntarTab, useAuthStore } from '@/stores/auth'
import '@/style.css'

// Pinia memegang keadaan milik klien (sesi, antrean toast); TanStack Query
// memegang salinan data server. Keduanya berdampingan, bukan bersaing —
// menaruh data server di Pinia berarti kita sendiri yang harus menulis ulang
// logika basi/muat ulang/ambil ulang yang sudah disediakan Query.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Panel ini dipakai beberapa pengurus sekaligus, jadi data dianggap
      // basi cukup cepat — tetapi tidak nol, supaya berpindah tab tidak
      // memicu badai permintaan.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      // 401/403 tidak akan sembuh dengan diulang; yang diulang hanya
      // kegagalan jaringan, dan hanya sekali.
      retry: (gagalKe, error) => {
        const status = (error as { status?: number })?.status
        if (status && status >= 400 && status < 500) return false
        return gagalKe < 1
      },
    },
  },
})

const app = createApp(App)
app.use(createPinia())
app.use(VueQueryPlugin, { queryClient })
app.use(router)
app.mount('#app')

// Sesi lama (refresh token di localStorage) dipindah ke cookie HttpOnly.
const auth = useAuthStore()
void auth.migrasiSesiLama()
// Akun yang berganti di tab lain langsung diikuti tab ini.
pasangSinkronAntarTab(auth)
